// extracted by mini-css-extract-plugin
export default {"wishlist":"Favourites_wishlist__HmQA7","wishlist__loader":"Favourites_wishlist__loader__OxdTe","wishlist__body":"Favourites_wishlist__body__HgJC7"};